import { typography } from '@dixa/lib-shared-tokens';
import { hexStringToNumber } from '../renderers/common/colors';
const bitmapTextOffset = -4;
const _baseBitmap = {
    fontSize: 14,
    tint: hexStringToNumber(typography.color.primary),
};
const normal = Object.assign(Object.assign({}, _baseBitmap), { fontName: 'OpenSans-Regular' });
const semibold = Object.assign(Object.assign({}, _baseBitmap), { fontName: 'OpenSans-SemiBold' });
export const textStyles = {
    bitmapTextOffset,
    normal,
    semibold,
};
